// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__vXTFg","select":"Header_select__3_ttk","clinic":"Header_clinic__8OH8I"};